import { render, staticRenderFns } from "./ButtonElement.vue?vue&type=template&id=82f0de7e&scoped=true&lang=html"
import script from "./ButtonElement.vue?vue&type=script&lang=js"
export * from "./ButtonElement.vue?vue&type=script&lang=js"
import style0 from "./ButtonElement.vue?vue&type=style&index=0&id=82f0de7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f0de7e",
  null
  
)

export default component.exports